/**
 * Practitioner available shift types
 */
export enum PractitionerShiftType {
    MORNING = 'morning',
    MIDDAY = 'midday',
    EVENING = 'evening',
}
